import React from 'react';
import { Typography, Popover, Space, Divider, Flex } from 'antd';
import dayjs from 'dayjs';
import getFormattedValue from 'store/redux/utils/getFormattedValue';
import { mdiCalendar, mdiUpdate, mdiAlertCircle } from '@mdi/js';
import Icon from '@mdi/react';
import Ninja from '@ninja';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';

const { Text } = Typography;

const ConversionInfoFormatter = ({ row }) => {
  const logs = row?.network_conversion_logs || [];

  if (!logs.length) return <Text className='text-sm font-medium text-color-light'>-</Text>;

  return (
    <Popover
      placement='right'
      content={
        <div direction='vertical'>
          {logs.map((item) => (
            <div key={item.id}>
              <Space direction='vertical'>
                <Flex gap='large' items='center'>
                  <Text strong>{item.event.charAt(0).toUpperCase() + item.event.slice(1)}</Text>

                  <Text className='text-success font-semibold'>
                    {getFormattedValue(item.value, item.currency)}
                  </Text>
                </Flex>
                <div className='grid gap-1'>
                  <Flex gap={4} align='center'>
                    <Icon path={mdiCalendar} size={0.6} color={Ninja.colors.light} />
                    <Text className='text-xs text-color-light'>
                      Created: {dayjs(item.created_at).format('DD MMM YYYY')}
                    </Text>
                  </Flex>
                  <Flex gap={4} align='center'>
                    <Icon path={mdiUpdate} size={0.6} color={Ninja.colors.light} />
                    <Text className='text-xs text-color-light '>
                      Updated: {dayjs(item.updated_at).format('DD MMM YYYY')}
                    </Text>
                  </Flex>
                </div>
                <Divider style={{ margin: '10px 0px' }} />
              </Space>
            </div>
          ))}
        </div>
      }
      className='flex items-center gap-1 cursor-pointer'
    >
      <Icon path={mdiAlertCircle} size={0.7} color={Ninja.colors.light} />
      <Text className='text-sm font-medium text-color-light'>
        {getFormattedNumber(logs.length)}
      </Text>
    </Popover>
  );
};

export default ConversionInfoFormatter;
